export default {
  DRAWER: null,
  PRIMARY_COLOR: '#000',
  EDITING_COLOR: '#FFF',
  LOADING: false,
};
